import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || ''

export default function CancelarReserva() {
  const { token } = useParams()
  const [estado, setEstado] = useState('confirmando')  // confirmando | exito | error | ya_cancelada
  const [mensaje, setMensaje] = useState('')

  useEffect(() => {
    axios.post(`${API}/api/reservas/cancelar/${token}`)
      .then(() => setEstado('exito'))
      .catch(err => {
        const msg = err.response?.data?.error || ''
        if (msg.includes('ya estaba cancelada')) {
          setEstado('ya_cancelada')
        } else if (msg.includes('pasada')) {
          setEstado('error'); setMensaje('No se puede cancelar una reserva pasada.')
        } else {
          setEstado('error'); setMensaje('No se encontró la reserva o el enlace no es válido.')
        }
      })
  }, [token])

  return (
    <div className="form-page">
      <div className="form-card" style={{ maxWidth: 480, textAlign: 'center' }}>
        {estado === 'confirmando' && (
          <>
            <p className="page-label">Un momento</p>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '2rem', fontWeight: 300 }}>Cancelando reserva...</h1>
          </>
        )}

        {estado === 'exito' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
            <p className="page-label">Cancelación confirmada</p>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.8rem', fontWeight: 300 }}>Reserva cancelada</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: '1rem' }}>
              Tu reserva ha sido cancelada correctamente. Si cambias de opinión, puedes hacer una nueva reserva cuando quieras.
            </p>
            <Link to="/reservas" className="btn-primary" style={{ display: 'inline-block', marginTop: '2rem', width: 'auto', padding: '1rem 2rem', textDecoration: 'none' }}>
              Hacer una nueva reserva
            </Link>
          </>
        )}

        {estado === 'ya_cancelada' && (
          <>
            <p className="page-label">Aviso</p>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.8rem', fontWeight: 300 }}>Esta reserva ya estaba cancelada</h1>
            <Link to="/" style={{ color: 'var(--gold)', display: 'block', marginTop: '2rem', fontSize: '0.75rem', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
              Volver al inicio
            </Link>
          </>
        )}

        {estado === 'error' && (
          <>
            <p className="page-label">Error</p>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.8rem', fontWeight: 300 }}>No se pudo cancelar</h1>
            <p style={{ color: '#e74c3c', fontSize: '0.85rem', marginTop: '1rem' }}>{mensaje}</p>
            <Link to="/" style={{ color: 'var(--gold)', display: 'block', marginTop: '2rem', fontSize: '0.75rem', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
              Volver al inicio
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
